export default __webpack_public_path__ + "static/media/cross.6fd38229.svg";